import { render } from "./PositionedKnowledgePanel.vue?vue&type=template&id=1461bf64&scoped=true"
import script from "./PositionedKnowledgePanel.vue?vue&type=script&lang=js"
export * from "./PositionedKnowledgePanel.vue?vue&type=script&lang=js"

import "./PositionedKnowledgePanel.vue?vue&type=style&index=0&id=1461bf64&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1461bf64"]])

export default __exports__